import { useLazyQuery } from "@apollo/client/react";import React, { useEffect, useMemo } from 'react';
import './listarMinutaGrilla.scss';
import { Grid } from '@mui/material';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { adaptImprimirMinutasDocumentosArray, GET_IMPRIMIR_MINUTA_DOCUMENTOS } from '../../../data/graphQL/queries/ImprimirMinuta/getImprimirMinutaDocumentos';


export const ListarMinutaDetalleDocs = ({
  dataRegistro,
  documentos,
  setDocumentos
}) => {
  const [getDocumentos, { data: dataDocumentos, loading: documentosLoading }] = useLazyQuery(GET_IMPRIMIR_MINUTA_DOCUMENTOS, {
    fetchPolicy: 'no-cache'
  });

	useEffect(() => {
		if (!dataDocumentos) return;
    setDocumentos(adaptImprimirMinutasDocumentosArray(dataDocumentos.documentosMinuta));
	}, [dataDocumentos]);

  useEffect(() => {
    if (!documentosLoading)
    getDocumentos({ variables: { idMinuta: dataRegistro?.idMinuta } });
  }, []);

  const initialColumns = [
  {
    field: 'descripcion',
    headerName: 'Documento',
    headerAlign: 'left',
    align: 'left',
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return <div style={{ paddingLeft: '18px' }}>
                            {row.descripcion}
                        </div>;
    }
  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [documentos]);

  return (
    <>
            <Grid container spacing={1} sx={{ marginTop: '10px' }}>                
                <Grid size={{ xs: 12, md: 12 }}>
                    <div className='section-title'>Documentación Adjunta</div>
                    <DataGridGenerico
            columns={columns}
            rows={documentos}
            toolbar={false}
            maxWidth={columns.reduce(
              (total, column) => total + (column.width || 0),
              0
            )}
            loading={documentosLoading} />
            
                </Grid> 
            </Grid>    
        </>);

};